// extracted by mini-css-extract-plugin
export default {"linksWrapper":"Links_linksWrapper__WxbpI","link":"Links_link__XcQlf","icon":"Links_icon__EYjGZ"};